import
{
    useL10n
} from "@ews/react-localization-context";


import
{
    FC,
    PropsWithChildren
} from "react";

import
{
    Sidebar,
    SidebarSection
} from "./Sidebar";

import
{
    RouteParams,
    useNamedRoutes
} from "../../NamedRoutes";

import type {
    MenuToggleProps
} from "../types";








type SidebarProps = MenuToggleProps & {
    routeParams?: RouteParams;
    title?: string;
};

const Maintenance: FC<SidebarProps & PropsWithChildren> = ({
    routeParams = {},
    onMenuToggle,
    title,
    children
}) =>
{
    const { translate: t } = useL10n();
    const { generate, params, router } = useNamedRoutes();

    title = title || t("[REACT_SYSTEMSETTINGS]");


    return (
        <Sidebar title={title} onMenuToggle={onMenuToggle}>
            <SidebarSection grow>


                {children}
            </SidebarSection>
        </Sidebar>
    );

};

export default Maintenance;
